import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _jsxFileName = "/Users/satya/Workspace/Callstack/react-navigation-core/src/navigators/createNavigator.js";
import React from 'react';
import invariant from '../utils/invariant';

function createNavigator(NavigatorView, router, navigationConfig) {
  var Navigator = function (_React$Component) {
    _inherits(Navigator, _React$Component);

    function Navigator() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Navigator);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Navigator)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.state = {
        descriptors: {},
        screenProps: _this.props.screenProps
      };
      return _this;
    }

    _createClass(Navigator, [{
      key: "render",
      value: function render() {
        return React.createElement(NavigatorView, _extends({}, this.props, {
          screenProps: this.state.screenProps,
          navigation: this.props.navigation,
          navigationConfig: navigationConfig,
          descriptors: this.state.descriptors,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 61
          }
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        var prevDescriptors = prevState.descriptors;
        var navigation = nextProps.navigation,
            screenProps = nextProps.screenProps;
        invariant(navigation != null, 'The navigation prop is missing for this navigator. In react-navigation 3 you must set up your app container directly. More info: https://reactnavigation.org/docs/en/app-containers.html');
        var state = navigation.state;
        var routes = state.routes;

        if (typeof routes === 'undefined') {
          throw new TypeError('No "routes" found in navigation state. Did you try to pass the navigation prop of a React component to a Navigator child? See https://reactnavigation.org/docs/en/custom-navigators.html#navigator-navigation-prop');
        }

        var descriptors = {};
        routes.forEach(function (route) {
          if (prevDescriptors && prevDescriptors[route.key] && route === prevDescriptors[route.key].state && screenProps === prevState.screenProps) {
            descriptors[route.key] = prevDescriptors[route.key];
            return;
          }

          var getComponent = router.getComponentForRouteName.bind(null, route.routeName);
          var childNavigation = navigation.getChildNavigation(route.key);
          var options = router.getScreenOptions(childNavigation, screenProps);
          descriptors[route.key] = {
            key: route.key,
            getComponent: getComponent,
            options: options,
            state: route,
            navigation: childNavigation
          };
        });
        return {
          descriptors: descriptors,
          screenProps: screenProps
        };
      }
    }]);

    return Navigator;
  }(React.Component);

  Navigator.router = router;
  Navigator.navigationOptions = navigationConfig.navigationOptions;
  return Navigator;
}

export default createNavigator;